// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "foxit-UIExtension-full" + "." + "c0d3bcb0ead166aa" + ".js";
};